import { IBienLaiHuyRequest } from "../../../model/request/bien-lai/IBienLaiHuyRequest";
import { IBienLaiPagingRequest } from "../../../model/request/bien-lai/IBienLaiPagingRequest";
import { IBienLaiThu } from "../../../model/respone/bien-lai/IBienLaiThu";
import {
  IBienLaiThuPaging,
  IPagingBienLaiResult,
} from "../../../model/respone/bien-lai/IBienLaiThuPaging";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export interface IBienLaiPagingBaseActionTypes<T> {
  request: number;
  data: T;
}
export const eBienLaiPagingActionsObj = {
  LOAD_START: {} as IBienLaiPagingRequest,
  LOAD_SUCCESS: {} as IPagingBienLaiResult,
  LOAD_ERRR: {} as string,

  CHANGE_REQUEST: {} as any,
  SHOW_DETAIL_MODAL: 0,
  HIDE_DETAIL_MODAL: undefined,

  SHOW_HUY_MODAL: {} as IBienLaiThuPaging,
  HIDE_HUY_MODAL: undefined,

  SHOW_HIDE_FILTER: {} as boolean,

  HUY_START: {} as IBienLaiHuyRequest,
  HUY_SUCCESS: {} as IBienLaiThu,
  HUY_ERRR: "",

  EXPORT_EXCEL_BAO_CAO_START: {} as IBienLaiPagingRequest,
  EXPORT_EXCEL_BAO_CAO_SUCCESS: "",
  EXPORT_EXCEL_BAO_CAO_ERRR: "",

  PRINT_BAO_CAO_START: {} as IBienLaiPagingRequest,
  PRINT_BAO_CAO_SUCCESS: "",
  PRINT_BAO_CAO_ERRR: "",
  PRINT_BAO_CAO_CLOSE: undefined,
};
export const eBienLaiPagingActionTypeIds = generateActionTypeIds(
  eBienLaiPagingActionsObj,
  "BIEN_LAI_PAGING"
);
export type IBienLaiPagingActionTypes = IGenericActionType<
  typeof eBienLaiPagingActionsObj,
  "BIEN_LAI_PAGING"
>;
